import { defineStore } from "pinia";

export const useProductStore = defineStore('product', {
    state: () => ({
        product: {},
        products: [],
    }),
    actions: {
        setProduct(product) {
            this.product = product
        },
        setProducts(products) {
            this.products = products
        },
        addProduct(product) {
            this.products.unshift(product)
        },
        updateProduct(product) {
            let index = this.products.findIndex(cl => cl.id === product.id)
            this.products.splice(index, 1, product)
        },
        deleteProduct(product) {
            let index = this.products.findIndex(cl => cl.id === product.id)
            this.products.splice(index, 1)
        },
    },
});